import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

/* Styled components */
const Wrapper = styled.div`
  min-height: 100vh;
  background: #fafafa;
  padding: 40px 20px;
`;

const Container = styled.div`
  max-width: 900px;
  margin: auto;
  background: #fff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
`;

const Title = styled.h1`
  font-size: 32px;
  margin-bottom: 30px;
`;

const Text = styled.p`
  font-size: 15px;
  line-height: 1.7;
  color: #555;
  margin-bottom: 8px;
`;

const SubTitle = styled.h3`
  font-size: 18px;
  margin: 20px 0 10px;
`;

const Imprint = () => {
  const { t } = useTranslation();
  const imprint = t("imprint", { returnObjects: true });

  return (
    <Wrapper>
      <Container>
        <Title>{imprint.title}</Title>

        <Text><strong>{imprint.company}</strong></Text>
        <Text>{imprint.name}</Text>
        <Text>{imprint.street}</Text>
        <Text>{imprint.postal_city}</Text>
        <Text>{imprint.country}</Text>

        <Text>
          <strong>{imprint.phone_label}:</strong> {imprint.phone}
        </Text>

        <Text>
          <strong>{imprint.email_label}:</strong>{" "}
          <a href={`mailto:${imprint.email}`}>{imprint.email}</a>
        </Text>

        <SubTitle>{imprint.content_responsible_title}</SubTitle>
        <Text>{imprint.content_responsible}</Text>

        <Text>
          <strong>{imprint.platform_head}</strong> {imprint.platform}
        </Text>

        <SubTitle>{imprint.disclaimer_title}</SubTitle>
        <Text>{imprint.disclaimer_text}</Text>
      </Container>
    </Wrapper>
  );
};

export default Imprint;
